@if (imageBase64 && !imageError) {
  <div class="b-grey p-xxs width-300" [ngClass]="loading ? 'absolute hide' : ''">
    <img class="width-full" [src]="imageBase64" (load)="imageLoaded()" (error)="loadImageError()" />
  </div>
}
@if (loading && !imageError && !rendered) { <span class="am-flex width-300 height-150 loading-animate"></span> }
@else {
  @if (imageError) { <img  class="width-100" [class.pb40]="signer" src="assets/images/broken-image.svg" />           }
  @if (signer    ) { <span class="absolute left-0 bottom-0 ml-xs mb5 text-s">Unterschrieben von: {{ signer }}</span> }
}
